package org.hs_soft.runmynesto.pages.home.sub_page.options.component.tabs.restaurant_manager.components.restaurant_project.list

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.css.Overflow
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.height
import com.varabyte.kobweb.compose.ui.modifiers.overflow
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.thenIf
import com.varabyte.kobweb.silk.components.style.toModifier
import org.hs_soft.runmynesto.domain.config.Dimen

import org.hs_soft.runmynesto.domain.config.Theme
import org.hs_soft.runmynesto.domain.config.VerticalScrollBehavior
import org.hs_soft.runmynesto.domain.config.showContentInOnePage
import org.hs_soft.runmynesto.domain.model.general.WindowSizeModeEnum
import org.hs_soft.runmynesto.domain.model.home.options.restaurant_manager.restaurant_project.RestaurantProject
import org.hs_soft.runmynesto.domain.model.home.options.restaurant_manager.restaurant_project.Room
import org.hs_soft.runmynesto.domain.util.Constants
import org.hs_soft.runmynesto.domain.util.Res
import org.hs_soft.runmynesto.domain.util.helper.Strings
import org.hs_soft.runmynesto.pages.components.CustomEditText
import org.jetbrains.compose.web.css.CSSSizeValue
import org.jetbrains.compose.web.css.CSSUnit
import org.jetbrains.compose.web.css.CSSUnitLength
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.css.vh

@Composable
fun RestaurantProject(
    modifier: Modifier = Modifier,
    fillMaxWidth: Boolean = false,
    selectedRoom: Room?,
    selectedRestaurantProject: RestaurantProject?,
    restaurantProjects: List<RestaurantProject?>?,
    windowSizeMode: WindowSizeModeEnum,
    searchValue: String,
    width: CSSSizeValue<out CSSUnitLength> = Dimen.restaurantProjectWidth,
    height: CSSSizeValue<CSSUnit.vh> =
        Constants.Responsive.restaurantProjectHeight.vh,
    onSearchValueChange: (String) -> Unit,
    onProjectClick: (RestaurantProject?) -> Unit,
    onRoomClick: (Room?, RestaurantProject?) -> Unit,
    onFloorClick: (RestaurantProject?) -> Unit,
) {

    Column(
        modifier = modifier
            .overflow(Overflow.Auto)
            .thenIf(
                selectedRoom==null,
                modifier.showContentInOnePage()
            )
            .thenIf(
                selectedRoom!=null,
                modifier.height(height)
            )
            .then(
                if (fillMaxWidth) Modifier.fillMaxWidth()
                else Modifier
            )
            .padding(
                leftRight = Dimen.normalPadding,
            ),
        horizontalAlignment = if (windowSizeMode== WindowSizeModeEnum.Desktop) Alignment.Start
        else Alignment.CenterHorizontally
    ) {

        CustomEditText(
            modifier=Modifier,
            width = width,
            label = "",
            value = searchValue,
            marginTop = 0.px,
            endIconPath = Res.PathIcon.searchBox,
            isRequired = false,
            hasLabelSpace = false,
            hint = Strings.current().search,
            onFocusIn = {},
            onFocusOut = {},
            onInputChange = {it, validation ->
                onSearchValueChange(it)
            },
        )


        Projects(
            modifier =VerticalScrollBehavior.toModifier(),
            windowSizeMode=windowSizeMode,
            selectedRestaurantProject=selectedRestaurantProject,
            selectedRestaurantRoom=selectedRoom,
            restaurantProjects=restaurantProjects,
            width = width,
            onProjectItemClick = {
                onProjectClick(it)
            },
            onFloorClick = {restaurantProjects->
                onFloorClick(restaurantProjects)
            },
            onRoomClick = {room,restaurantProject->
                onRoomClick(room,restaurantProject)
            }
        )
    }
}







